module.exports = __webpack_public_path__ + "592313b8284a4de3134d548787a0ad82.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-768.webp.png
// module id = 625
// module chunks = 0